import React, { useContext, useEffect } from "react";
import AppRoute from "./AppRoute";
import "./scss/app.scss";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useAuthContext } from "./shared/AuthContext";
import config from "./config";

import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-K7KMLHGB",
};

TagManager.initialize(tagManagerArgs);

function App() {
  const { user } = useAuthContext();

  console.log('app init, user: ',user);

  useEffect(() => {
    if (!config.SHOULD_DO_REDIRECT_CHAT_TO_NEW_BOT) {
      return;
    }

    const newChatbotUrl = config.REDIRECT_TO_NEW_BOT_CHECK_URL;

    if (!newChatbotUrl) {
      return;
    }

    const checkRedirect = async () => {
      console.log('check is need redirect to new chatbot');
      const path = window.location.pathname;

      let scope = null;

      if (path.startsWith("/chatbot-lawyer")) {
        scope = "lawyer";
      } else if (path.startsWith("/chatbot")) {
        scope = "client";
      }

      const customer = new URL(window.location.href).searchParams.get('customer');

      const dealId = customer ? customer.match(/\d+/)?.[0] : null;

      console.log('redirect scope is ', scope);
      console.log('dealId is: ', dealId);

      if (!scope || !dealId) {
        return;
      }

      try {
        const res = await fetch(`${newChatbotUrl}/api/sessions/should-redirect-old-chat?scope=${scope}&dealId=${dealId}`);
        console.log('check redirect result:', res);
        if (!res.ok) return;

        const data = await res.json();

        if (data?.redirectUrl) {
          window.location.replace(data.redirectUrl);
        }
      } catch (e) {
        console.error("Redirect check failed", e);
      }
    };

    if (!user) {
      return;
    }

    checkRedirect();

  }, [user]);

  return (
    <div className="App">
      <AppRoute />
    </div>
  );
}

export default App;
